import { skipToken, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export type UseOutputDataStreamTypesProps = Readonly<{
    dataTypeId?: number;
}>;

export function useOutputDataStreamTypes({ dataTypeId }: UseOutputDataStreamTypesProps) {
    return useQuery({
        queryKey: ['output-data-stream-types', dataTypeId],

        queryFn: dataTypeId
            ? () => sdClient.getSupportedOutputSensorTypesForDataType({ dataTypeId })
            : skipToken,

        enabled: dataTypeId !== undefined,
    });
}
